
// DeleteDevicePopup.js
import React from "react";
import "../../features/devices/components/DeleteDevice.css";


const DeleteCustomerPopup = ({ onClose, onDelete, selectedCustomer ,isDeleting}) => {
  const handleDelete = () => {
    onDelete();
  };
  

  return (
    <div className="delete-device-popup-container">
      <div className="delete-device-header-container">
        <h3 className="delete-device-title">Delete Customer</h3>
        <button className="delete-device-cancel-button" onClick={onClose}>
          ✖
        </button>
      </div>
      <div className="delete-device-content-container">
        <p>
          Are you sure you want to delete this customer?
          <br />
          <br />
          <strong>Customer Name:</strong> {selectedCustomer?.first_name } {selectedCustomer?.last_name}
        </p>
        <div className="delete-device-form-actions">
          <button
            className="delete-device-delete-button"
            onClick={handleDelete}
            disabled={isDeleting} 
          >
             {isDeleting ? (
              <span className="spinner-small"></span> // show loader
            ) : (
              "Delete"
            )}
          </button>
          <button className="delete-device-cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCustomerPopup;
